export default __webpack_public_path__ + "static/media/ic_promotion_noti.db6b2bc4.svg";